// =====================================================================================
// INVRT Radar — web console — trial state label
//
// sites.trial_state is the database's vocabulary (trial, converted, expired, …). The badge
// shows a sentence a tenant reads, never the raw token; an unknown value falls back to a
// plain "Trial: <state>" rather than hiding it.
// =====================================================================================

const LABELS: Record<string, string> = {
  trial: "Free trial",
  active: "Free trial",
  converted: "Trial converted",
  expired: "Trial ended",
  cancelled: "Trial cancelled",
};

export function trialLabel(state: string | null | undefined): string {
  if (!state) return "Trial";
  return LABELS[state] ?? `Trial: ${state.replace(/_/g, " ")}`;
}
